// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__sjKQD","title":"ClientCherryInfo_title__3O0-M","itemText":"ClientCherryInfo_itemText__3S7-a"};